import React from 'react';
import { useKeycloak } from '../../providers/KeycloakProvider';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authSelector } from '../../features/auth/authSlice';


//Composant de protection des routes nécessitant une authentification et le rôle IT
const RequireKeycloakAuth = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const location = useLocation();
  const { user } = useSelector(authSelector);

  if (!initialized) {
    return null; 
  }

  if (!keycloak.authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const hasItRole = user?.hasItRole || false;

  if (!hasItRole) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default RequireKeycloakAuth;
